export const wait = (milliseconds: number) =>
  new Promise(resolve => setTimeout(resolve, milliseconds))

export const noticeablyAsync = <T>(
  task: () => Promise<T>,
  milliseconds = 600
): (() => Promise<T>) => () =>
  Promise.all([task(), wait(milliseconds)]).then(
    ([result]: [T, unknown]) => result
  )

export const periodically = (
  action: () => Promise<void>,
  repeatEvery: number
): [() => void, () => void] => {
  let intervalHandle: NodeJS.Timeout = null
  const periodicallyDoAction = () =>
    action().then(() => (intervalHandle = setInterval(action, repeatEvery)))
  const stopAction = () => clearInterval(intervalHandle)
  return [periodicallyDoAction, stopAction]
}

export const schedule = (time: number) => <R>(f: () => R): Promise<R> =>
  new Promise(resolve =>
    setTimeout(() => {
      const result = f()
      resolve(result)
    }, time)
  )

export const offload = schedule(0)
